import { Header } from '@amzn/awsui-components-react';
import { useSearchParams } from 'react-router-dom';
import { featureIsEnabled, useFeatures } from '../hooks/features';
import { useLocalizedText } from '../hooks/localizedText';
import { NAVIGATION_REDESIGN, NON_PROFIT_SEARCH } from '../utils/constants';

const I18N = 'nonProfitProfile';

/**
 * Shell for a non-profit's profile. It renders a heading and nothing else: a coordinator who follows
 * a link here, or lands on it from a shared URL, sees no organization at all, not even the one named
 * in `causeId`. Nothing is fetched and the id is not read.
 *
 * The heading is placeholder copy with no id in the website.nonprofits translation bundle, so it
 * reads English in every locale rather than spending a translation cycle on text due to be replaced:
 * the finished page is headed by the organization's own name, which is data and never translated.
 */
export function NonProfitProfile() {
  const { t } = useLocalizedText(['nonprofits', 'translation']);

  return (
    <div data-testid="nonprofit-profile-page">
      <Header variant="h1">{t(`${I18N}.title`)}</Header>
    </div>
  );
}

/** Gated on both flags, for the reasons given on NonProfitSearchView. */
export function NonProfitProfileView() {
  const [searchParams] = useSearchParams();
  const features = useFeatures();

  if (
    featureIsEnabled(NON_PROFIT_SEARCH, features, searchParams) &&
    featureIsEnabled(NAVIGATION_REDESIGN, features, searchParams)
  ) {
    return <NonProfitProfile />;
  }
  return <></>;
}
